import { memo } from 'react';

import { Link } from '../../Link/Link';
import { Text } from '../../Text/Text';
import { BreadcrumbLink } from '../types';
import './BreadcrumbItem.css';

interface Props {
  link: BreadcrumbLink;
  isLast?: boolean;
  /** Accessible label for the loading placeholder shown when `link.isLoading`. */
  loadingLabel?: string;
}
export const BreadcrumbItem = memo(({ isLast, link, loadingLabel }: Props) => {
  let linkContent;
  if (link.isLoading) {
    linkContent = (
      <span
        aria-label={loadingLabel}
        className="eds-breadcrumb-item-skeleton"
        role="status"
      />
    );
  } else if (isLast) {
    // Regular weight, like the ancestors: color alone marks the current page, so
    // the trail reads as chrome rather than competing with the page title.
    linkContent = <Text variant="body-m">{link.text}</Text>;
  } else {
    linkContent = <Link href={link.path} text={link.text} />;
  }

  return (
    <span
      aria-current={isLast ? 'page' : undefined}
      className="eds-breadcrumb-item"
    >
      {linkContent}
    </span>
  );
});

BreadcrumbItem.displayName = 'BreadcrumbItem';
